import { ModalManager } from '@shared/components/providers/ModalProvider';
import PageView from '@shared/components/PageView';
import { getLabel } from '@shared/utils';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import { Box, Button, Chip, Divider, Stack, Typography } from '@mui/material';
import React from 'react';

interface RoleDetailsViewProps {
  role: any;
}

const RoleDetailsView: React.FC<RoleDetailsViewProps> = ({ role }) => {
  return (
    <>
      <PageView title={getLabel('roleDetails')}>
        <PageView.Content>
          <Stack spacing={3} direction="column">
            <Stack spacing={3} direction="row" sx={{ alignItems: 'center' }}>
              <Typography noWrap sx={{ width: '180px', fontWeight: 'bold' }}>
                {getLabel('id')}:
              </Typography>
              <Typography noWrap>{role.role_id}</Typography>
            </Stack>
            <Stack spacing={3} direction="row" sx={{ alignItems: 'center' }}>
              <Typography noWrap sx={{ width: '180px', fontWeight: 'bold' }}>
                {getLabel('roleName')}:
              </Typography>
              <Typography noWrap>{role.role_name}</Typography>
            </Stack>
            <Stack spacing={3} direction="row" sx={{ alignItems: 'center' }}>
              <Typography noWrap sx={{ width: '180px', fontWeight: 'bold' }}>
                {getLabel('typeCorrespondent')}:
              </Typography>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {(role?.correspondent_types || []).length > 0 ? (
                  role.correspondent_types.map((item: any) => (
                    <Chip key={item.id} label={item.name} color="primary" size="small" />
                  ))
                ) : (
                  <Chip label="N/A" size="small" color="default" />
                )}
              </Box>
            </Stack>
            <Stack spacing={3} direction="row" sx={{ alignItems: 'self-start' }}>
              <Typography noWrap sx={{ minWidth: '180px', fontWeight: 'bold' }}>
                {getLabel('rolePermissions')}:
              </Typography>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {(role?.permissions || []).length > 0 ? (
                  role.permissions.map((item: any) => (
                    <Chip key={item.id} label={item.name} variant="outlined" size="small" icon={<VerifiedUserIcon />} />
                  ))
                ) : (
                  <Chip label="N/A" size="small" color="default" />
                )}
              </Box>
            </Stack>
          </Stack>
        </PageView.Content>
      </PageView>
      <Divider orientation="horizontal" flexItem sx={{ backgroundColor: '#7025c6', marginTop: '24px' }} />
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '20px' }}>
        <Button
          variant="outlined"
          sx={{ mt: 3, ml: 1 }}
          color="primary"
          onClick={() => {
            ModalManager.closeModal();
          }}>
          {getLabel('close')}
        </Button>
      </Box>
    </>
  );
};

export default RoleDetailsView;
